/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

import localStorageUtil from 'src/utils/localStorageUtil';

import store from 'src/store';
import brandApi from 'src/api/brandApi';

import useLogin from './use-login';

const useInitApp = () => {
  const brandCode = localStorageUtil.getBrandCode();

  // 관리자 정보 atom
  const setManagerInfo = useSetAtom(store.manager.mangerInfoAtom);

  const loginHook = useLogin();
  
  // 브랜드 관리자 정보 호출 함수
  const getBrandInfo = async () => {
    if (!brandCode) return;

    const response = await brandApi.brandManager(brandCode);
    const data = response?.data?.data;

    if (!data || Object.keys(data).length === 0) return;

    const { name, email, phone } = data;
    setManagerInfo({ name, email, phone });
  };

  useEffect(() => {
    // 초기화 시 브랜드 정보와 멤버 정보 호출

    getBrandInfo();
    // 로그인 페이지가 아닌 경우 멤버 정보 호출
    if (!window.location.pathname.includes('login')) {
      loginHook.getMembershipInfo();
    }
  }, [brandCode]);
};

export default useInitApp;
